import React, { ReactElement } from 'react';
import { SvgIcon } from '@material-ui/core';
import { CancelRounded } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import BasicModal from '../../../../modules/modals/BasicModal';
import JoinActionButton from '../../JoinActionButton';
import {
  Description,
  HeadlineContainer,
  StyledContainer,
  SuccessTitle,
  Title,
  confirmModalStyle,
  selfieWallContentStyle,
} from '../SelfieVerificationStyle';
import { CloseBtn, DashlineSeparator, closeButton } from '../../../common/CommonStyle';
import useMediaBreakpoints from '../../../../hooks/useMediaBreakpoints';
import {
  refreshProfile,
  setFaceLivenessStatus,
  setShowSelfieVerificationWall,
} from '../../../../actions/profileActions';

const SuccessModal: React.FC<{ showSuccessModal: boolean }> = ({ showSuccessModal }): ReactElement => {
  const { isMobile } = useMediaBreakpoints();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(refreshProfile());
    dispatch(setShowSelfieVerificationWall(false));
    dispatch(setFaceLivenessStatus(null));
  };

  return (
    <>
      <BasicModal
        isOpen={showSuccessModal}
        hideClose={true}
        customStyle={confirmModalStyle}
        customContentStyle={selfieWallContentStyle}
        onClose={handleClose}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
      >
        <CloseBtn
          onClick={handleClose}
          style={{ top: isMobile ? '-50px' : '-25px', right: isMobile ? '-18px' : '-42px' }}
        >
          <SvgIcon component={CancelRounded} style={closeButton} />
        </CloseBtn>
        <HeadlineContainer isJoinFlow={true}>
          <Title>Selfie Verification</Title>
          <DashlineSeparator style={{ width: '100%' }} />
          <SuccessTitle>Success!</SuccessTitle>
          <Description>
            We’ve successfully captured your selfie. Our moderators will now verify your account.
          </Description>
          <Description customStyle={{ fontWeight: 600 }}>Thank you for helping to keep WYP safe!</Description>
          <DashlineSeparator style={{ width: '100%' }} />
        </HeadlineContainer>
        <StyledContainer>
          <div style={{ textAlign: 'center' }}>
            <JoinActionButton
              label={`Close`}
              isDefault={true}
              onClick={handleClose}
              customStyle={{ marginBottom: 20, minWidth: '190px', borderRadius: 4 }}
            />
          </div>
        </StyledContainer>
      </BasicModal>
    </>
  );
};

export default SuccessModal;
